<template>
  <div v-if="object">
    <div class="row text-white" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{item.object.category ? item.object.category.name : 'категория не определена' + '(' + (item.object.product ? fieldView(item.object.product.name) : 'номенклатура не определена') + ')'}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <items-option :label="'Категория'" :object="object.category" @update="setCategory" :type="'productCategory'">
        </items-option>
      </div>
      <div class="col-md-8">
        <items-option v-if="page" :page="page" :label="'Номенклатура'" :object="object.product" @update="setProduct" :type="'product'">
        </items-option>
        <b v-else>Для выбора номенклатуры необходимо определить категорию</b>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-input label="Количество"
                    v-model="object.quantity"
                    :value="object.quantity"
                    :number="true"
        ></base-input>
      </div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       page: null,
       inSave: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       this.inSave = true;
       try {
         let renewed = await this.$repo.save(this.object, this.type);
         if (renewed) {
           this.item.object = renewed;
           this.item.id = renewed.id;
           this.object = JSON.parse(JSON.stringify(renewed));
           this.inSave = false;
           this.toView();
         }
       } catch(error) {
         this.inSave = false;
       }
     },
     setCategory(value) {
       if (value && value !== this.object.category) {
         this.object.category = value;
         this.setPage();
       }
     },
     setProduct(value) {
       this.object.product = value;
       if (!this.object.quantity) {
         this.object.quantity = 1;
       }
     },
     setPage() {
       this.page = {
         page: 0, pageSize: 100000, sortBy: 'name', sortDirection: true,
         filterMap: {category: this.object.category.id}
       }
     }
   },
   mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
     if (this.object.category) {
       this.category = this.object.category;
       this.setPage();
     }
   }
 }
</script>
